/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerStatus } from './PamPlayerStatus';
import {
    PamPlayerStatusFromJSON,
    PamPlayerStatusFromJSONTyped,
    PamPlayerStatusToJSON,
} from './PamPlayerStatus';
import type { PamDuplicateCandidate } from './PamDuplicateCandidate';
import {
    PamDuplicateCandidateFromJSON,
    PamDuplicateCandidateFromJSONTyped,
    PamDuplicateCandidateToJSON,
} from './PamDuplicateCandidate';
import type { PamVerificationDetailSubmittedPii } from './PamVerificationDetailSubmittedPii';
import {
    PamVerificationDetailSubmittedPiiFromJSON,
    PamVerificationDetailSubmittedPiiFromJSONTyped,
    PamVerificationDetailSubmittedPiiToJSON,
} from './PamVerificationDetailSubmittedPii';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';
import type { PamVerificationHistoryEntry } from './PamVerificationHistoryEntry';
import {
    PamVerificationHistoryEntryFromJSON,
    PamVerificationHistoryEntryFromJSONTyped,
    PamVerificationHistoryEntryToJSON,
} from './PamVerificationHistoryEntry';

/**
 * Full detail for one failed verification, including decrypted submitted PII.
 * @export
 * @interface PamVerificationDetail
 */
export interface PamVerificationDetail {
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetail
     */
    email?: string | null;
    /**
     * 
     * @type {Array<PamDuplicateCandidate>}
     * @memberof PamVerificationDetail
     */
    duplicateCandidates: Array<PamDuplicateCandidate>;
    /**
     * 
     * @type {Array<PamVerificationHistoryEntry>}
     * @memberof PamVerificationDetail
     */
    history: Array<PamVerificationHistoryEntry>;
    /**
     * 
     * @type {PamVerificationDetailSubmittedPii}
     * @memberof PamVerificationDetail
     */
    submittedPii: PamVerificationDetailSubmittedPii;
    /**
     * 
     * @type {number}
     * @memberof PamVerificationDetail
     */
    maxAttempts: number;
    /**
     * 
     * @type {number}
     * @memberof PamVerificationDetail
     */
    attemptCount: number;
    /**
     * 
     * @type {PamPlayerStatus}
     * @memberof PamVerificationDetail
     */
    accountStatus: PamPlayerStatus;
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamVerificationDetail
     */
    status: PamPlayerVerificationStatus;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetail
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetail
     */
    clerkUserId: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetail
     */
    pamPlayerId: string;
}



/**
 * Check if a given object implements the PamVerificationDetail interface.
 */
export function instanceOfPamVerificationDetail(value: object): value is PamVerificationDetail {
    if (!('duplicateCandidates' in value) || value['duplicateCandidates'] === undefined) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    if (!('submittedPii' in value) || value['submittedPii'] === undefined) return false;
    if (!('maxAttempts' in value) || value['maxAttempts'] === undefined) return false;
    if (!('attemptCount' in value) || value['attemptCount'] === undefined) return false;
    if (!('accountStatus' in value) || value['accountStatus'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('clerkUserId' in value) || value['clerkUserId'] === undefined) return false;
    if (!('pamPlayerId' in value) || value['pamPlayerId'] === undefined) return false;
    return true;
}

export function PamVerificationDetailFromJSON(json: any): PamVerificationDetail {
    return PamVerificationDetailFromJSONTyped(json, false);
}

export function PamVerificationDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamVerificationDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'duplicateCandidates': ((json['duplicateCandidates'] as Array<any>).map(PamDuplicateCandidateFromJSON)),
        'history': ((json['history'] as Array<any>).map(PamVerificationHistoryEntryFromJSON)),
        'submittedPii': PamVerificationDetailSubmittedPiiFromJSON(json['submittedPii']),
        'maxAttempts': json['maxAttempts'],
        'attemptCount': json['attemptCount'],
        'accountStatus': PamPlayerStatusFromJSON(json['accountStatus']),
        'status': PamPlayerVerificationStatusFromJSON(json['status']),
        'displayName': json['displayName'],
        'clerkUserId': json['clerkUserId'],
        'pamPlayerId': json['pamPlayerId'],
    };
}

export function PamVerificationDetailToJSON(value?: PamVerificationDetail | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'duplicateCandidates': ((value['duplicateCandidates'] as Array<any>).map(PamDuplicateCandidateToJSON)),
        'history': ((value['history'] as Array<any>).map(PamVerificationHistoryEntryToJSON)),
        'submittedPii': PamVerificationDetailSubmittedPiiToJSON(value['submittedPii']),
        'maxAttempts': value['maxAttempts'],
        'attemptCount': value['attemptCount'],
        'accountStatus': PamPlayerStatusToJSON(value['accountStatus']),
        'status': PamPlayerVerificationStatusToJSON(value['status']),
        'displayName': value['displayName'],
        'clerkUserId': value['clerkUserId'],
        'pamPlayerId': value['pamPlayerId'],
    };
}

